import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function ClearLocalStorage() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const itemsToKeep = ["isNewCalendarVersion"];
    const preserved = itemsToKeep.map((key) => [
      key,
      localStorage.getItem(key),
    ]);

    localStorage.clear();

    preserved.forEach(([key, value]) => {
      if (value !== null) {
        localStorage.setItem(key, value);
      }
    });

    const params = new URLSearchParams(location.search);
    const redirectTo = params.get("redirect") || "/";

    history.replace(redirectTo);
  }, [history, location.search]);

  return null;
}
